/** @jsxImportSource theme-ui */
import { Checkbox, Flex, Box, Link } from "theme-ui";
import { colors, typography } from "../../styles/theme";
import { getCommonData } from "@greythr/shared-utils/regionContent";

const EmailConsentCheckbox = ({
  checked,
  onChange,
  customStyles = {},
  regionCode,
  customText,
}) => {
  const data = getCommonData(regionCode)?.centralDemo;
  const consentText = customText || data?.emailConsentCheckbox;

  return (
    <Flex
      sx={{
        mt: "1.5rem",
        alignItems: "flex-start",
        ...customStyles,
      }}
    >
      <label htmlFor="emailConsent" style={{ cursor: "pointer" }}>
        <Checkbox
          id={"emailConsent"}
          name={"emailConsent"}
          checked={checked}
          onChange={onChange}
          sx={checkBoxStyles}
        />
      </label>
      <Box
        sx={{ ...typography.textSm, color: colors.neutral900 }}
        onClick={() => document.getElementById("emailConsent")?.click()}
        style={{ cursor: "pointer" }}
      >
        {consentText}{" "}
        <Link
          href="/privacy-policy/"
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
          sx={{ ...typography.textSm, color: colors.primaryMain }}
        >
          {data?.privacyPolicy}
        </Link>
      </Box>
    </Flex>
  );
};

const { checkBoxStyles } = {
  checkBoxStyles: {
    "input:checked ~ &": {
      color: colors.primaryMain,
      bg: colors.white,
    },
    color: colors.neutral400,
    bg: colors.white,
    appearance: "none",
    width: "1.5rem",
    border: "0px solid",
    height: "1.5rem",
    "input:focus ~ &": {
      backgroundColor: colors.white,
    },
  },
};

export default EmailConsentCheckbox;
